import React from 'react'
import { HashLink } from 'react-router-hash-link';


function Footer() {

  return <div>
    <footer
      className="text-center text-lg-start text-dark"
      style={{ backgroundColor: "#ECEFF1" }}
    >
      <section
        className="d-flex justify-content-between p-4 text-white"
        style={{ backgroundColor: "#f6004c" }}
      >
        <div className="me-5">
          <span>Get connected with us on social networks:</span>
        </div>

        <div>
          <a href="https://www.facebook.com/profile.php?id=100078909970403&mibextid=ZbWKwL" target='_blank' className="text-white me-4">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://instagram.com/wellfit_hepi?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D" target='_blank' className="text-white me-4">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </section>

      <section className="">
        <div className="container text-md-start mt-5  ">
          <div className="row mt-3 d-flex justify-content-between">
            <div className="col-md-3 col-lg-4 col-xl-3 mb-4 mt-3">
              <h6 className="text-uppercase fw-bold" style={{textAlign:'left'}}>Community Name</h6>
              <hr
                className="mb-4 mt-0"
                style={{textAlign:'left' ,width: "60px", backgroundColor: "#f6004c", height: "2px", opacity: 1, border: 'none' }}
              />
              <p className='text-start d-flex'>
               <p className='teamname'>Team </p>&nbsp; <p className='teamname'>Rapid</p>&nbsp; <p className='teamname'>Movers</p>
              </p>
            </div>

           
            <div className="col-md-2 col-lg-2 col-xl-2 mt-3">
              <h6 className="text-uppercase fw-bold text-start">Titles</h6>
              <hr
                className="mb-4 mt-0  text-start"
                style={{ width: "60px", backgroundColor: "#f6004c", height: "2px", opacity: 1, border: 'none' }}
              />
              <p className='text-start'>
                <HashLink to="/#onlineclub" style={{ textDecoration: 'none' }} className="footerLink text-dark">Online Club</HashLink>
              </p>
              <p className='text-start'>
                <HashLink to="/#workout" style={{ textDecoration: 'none' }} className="footerLink text-dark">Live Workout</HashLink>
              </p>
              <p className='text-start'>
                <HashLink to="/#photos" style={{ textDecoration: 'none' }} className="footerLink text-dark">Photos</HashLink>
              </p>
              <p className='text-start'>
                <HashLink to="/#Offlineclub" style={{ textDecoration: 'none' }} className="footerLink text-dark">Offline Club</HashLink>
              </p>
              <p className='text-start'>
                <HashLink to="/#dietplanning" style={{ textDecoration: 'none' }} className="footerLink text-dark">Diet Planning</HashLink>
              </p>
              <p className='text-start'>
                <HashLink to="/contactus/#contactus" style={{ textDecoration: 'none' }} className="footerLink text-dark">Register Now</HashLink>
              </p>
            </div>

            <div className="col-md-4 col-lg-4 mt-3 mb-3">
              <h6 className="text-uppercase fw-bold text-start">Contact</h6>
              <hr
                className="mb-4 mt-0 text-start"
                style={{ width: "60px", backgroundColor: "#f6004c", height: "2px", opacity: 1, border: 'none' }}
              />
              <a href="mailto:gadhesariyahepi1122@gmail.com" style={{textDecoration:' none' ,color:'black',letterSpacing:'1px'}}> <p className='text-start' ><i className="fas fa-envelope mr-3" style={{ color: '#f6004c', marginRight: '20px' }}></i> gadhesariyahepi1122@gmail.com</p></a>
            </div>
          </div>
        </div>
      </section>
    </footer>
  </div>
}



export default Footer
